
import { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

interface LoginCardProps {
  title: string;
  description: string;
  children: ReactNode;
}

export const LoginCard = ({ title, description, children }: LoginCardProps) => {
  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>{children}</CardContent>
      <CardFooter className="flex flex-col">
        <p className="text-sm text-gray-500 text-center">
          By logging in, you agree to our terms and conditions.
        </p>
      </CardFooter>
    </Card>
  );
};
